module.exports = __webpack_public_path__ + "img/girl-sweeping.fa4fb39d.png";